"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendInfoReportBeacon = exports.sendInfoReport = exports.resetReportSent = exports.isReportAlreadySent = exports.trackAttemptTime = void 0;
const uiConfigs_1 = require("@app/utils/uiConfigs");
const apiFetch_1 = require("@app/utils/apiFetch");
const trackAttemptTime = (infoRep, isCorrect) => {
    var _a;
    const newData = [...infoRep];
    const lastIdx = newData.length - 1;
    if (lastIdx >= 0 && ((_a = newData[lastIdx]) === null || _a === void 0 ? void 0 : _a.startTime)) {
        const timeOfRepetition = (Date.now() - newData[lastIdx].startTime) / 1000;
        newData[lastIdx] = Object.assign(Object.assign({}, newData[lastIdx]), { category_name: isCorrect ? uiConfigs_1.categoryIds[uiConfigs_1.categoriesName.correct] : uiConfigs_1.categoryIds[uiConfigs_1.categoriesName.incorrect], system_time: parseFloat(timeOfRepetition.toFixed(1)) });
        console.log('[ExerciseReport] trackAttemptTime rep=' + (lastIdx + 1) + ' time=' + timeOfRepetition.toFixed(1) + 's correct=' + isCorrect);
    }
    return newData;
};
exports.trackAttemptTime = trackAttemptTime;
const buildReportPayload = (info_reps, ex_id, userId, checkedAnsweredData, finished = 1) => {
    const answeredData = checkedAnsweredData === null || checkedAnsweredData === void 0 ? void 0 : checkedAnsweredData.filter(item => item === null || item === void 0 ? void 0 : item.isChecked);
    const correctAnswerCount = answeredData === null || answeredData === void 0 ? void 0 : answeredData.filter(item => item === null || item === void 0 ? void 0 : item.isCorrect);
    let cumulativeSum = 0;
    const final_result = {
        "percent_category": ((correctAnswerCount === null || correctAnswerCount === void 0 ? void 0 : correctAnswerCount.length) / (answeredData === null || answeredData === void 0 ? void 0 : answeredData.length)) * 100,
        "percent_errors": 100 - ((correctAnswerCount === null || correctAnswerCount === void 0 ? void 0 : correctAnswerCount.length) / (answeredData === null || answeredData === void 0 ? void 0 : answeredData.length)) * 100,
        count_replays: answeredData === null || answeredData === void 0 ? void 0 : answeredData.length,
        finished
    };
    // system_time = end time of each repetition, measured from exercise start (not start_time)
    const newInfoReps = info_reps === null || info_reps === void 0 ? void 0 : info_reps.map((item, idx) => {
        cumulativeSum += (item === null || item === void 0 ? void 0 : item.system_time) || 0;
        const { startTime: _ } = item, newData = __rest(item, ["startTime"]);
        return Object.assign(Object.assign({}, newData), { system_time: Math.round(cumulativeSum), local_errors: [], category_name: (newData === null || newData === void 0 ? void 0 : newData.category_name)
                ? newData === null || newData === void 0 ? void 0 : newData.category_name
                : uiConfigs_1.categoryIds[uiConfigs_1.categoriesName.incorrect], rep_id: idx + 1 });
    });
    return {
        "user": { "id": userId },
        "exercise": {
            "abort_exercise": {},
            "final_result": final_result,
            "info_reps": newInfoReps,
            "id": ex_id
        }
    };
};
let _reportSent = false;
const isReportAlreadySent = () => _reportSent;
exports.isReportAlreadySent = isReportAlreadySent;
const resetReportSent = () => { _reportSent = false; };
exports.resetReportSent = resetReportSent;
const sendInfoReport = (info_reps, ex_id, userId, checkedAnsweredData) => {
    _reportSent = true;
    const payload = buildReportPayload(info_reps, ex_id, userId, checkedAnsweredData, 1);
    console.log('[ExerciseReport] sendInfoReport payload:', JSON.stringify(payload));
    return (0, apiFetch_1.apiFetch)('/exercise_report', {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "jwt": "ezspeech!11",
        },
    });
};
exports.sendInfoReport = sendInfoReport;
const sendInfoReportBeacon = (info_reps, ex_id, userId, checkedAnsweredData) => {
    const payload = buildReportPayload(info_reps, ex_id, userId, checkedAnsweredData, 0);
    try {
        (0, apiFetch_1.apiFetch)('/exercise_report', {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
                "jwt": "ezspeech!11",
            },
            keepalive: true,
        });
    }
    catch (e) {
        // silently fail — page is unloading
    }
};
exports.sendInfoReportBeacon = sendInfoReportBeacon;
